/** Llamadas HTTP del feature multas. */
import { apiRequest } from "../../lib/api";

export type OrigenMulta = "Reunion" | "Corte" | "Manual";
export type EstadoMulta = "Pendiente" | "Facturada" | "Pagada" | "Anulada";

export interface MultaRead {
  id: number;
  empresa_id: number;
  socio_id: number;
  monto: number;
  motivo: string;
  origen: OrigenMulta;
  observacion: string | null;
  fecha_vencimiento: string | null;
  fecha_generacion: string;
  reunion_id: number | null;
  lectura_id: number | null;
  estado: EstadoMulta;
  created_at: string;
  updated_at: string;
}

export interface MultaCreatePayload {
  socio_id: number;
  monto: number;
  motivo: string;
  origen?: OrigenMulta;
  observacion?: string | null;
  fecha_vencimiento?: string | null;
  reunion_id?: number | null;
}

export function listarPendientesEmpresa(): Promise<MultaRead[]> {
  return apiRequest<MultaRead[]>("/api/v1/multas/pendientes");
}

export function listarPorSocio(
  socioId: number,
  soloPendientes = false,
): Promise<MultaRead[]> {
  const qs = soloPendientes ? "?solo_pendientes=true" : "";
  return apiRequest<MultaRead[]>(`/api/v1/multas/socios/${socioId}${qs}`);
}

export function obtenerMulta(id: number): Promise<MultaRead> {
  return apiRequest<MultaRead>(`/api/v1/multas/${id}`);
}

export function registrarMulta(payload: MultaCreatePayload): Promise<MultaRead> {
  return apiRequest<MultaRead>("/api/v1/multas", {
    method: "POST",
    body: payload,
  });
}
